<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Change Server default Storage</span>
                <span class="default-settings-subtitle">Change the default storage of the server.</span>
            </div>

            <div class="backup" style="margin-bottom: 35px;">
                <div class="columns is-multiline is-vcentered">
                    <div class="column is-full" style="margin-top:-10px;">
                        <div class="notification is-default" style="font-size:13px;">
                            When adding a new database that will be backed-up through this server, Weap.io will use the storage selected below as default for that database. You can change the storage of the database later if you don't want to use the default one.
                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="selectedStorage">
                                        <option v-for="storage in storages" v-bind:key="storage.id" :value="storage.id">{{ storage.name + ' (' + storage.provider + ')' }}</option>
                                    </select>
                                </div>
                                <div class="icon is-left is-custom-icon-left">
                                    <font-awesome-icon icon="hdd"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="column is-6">
                        <label class="checkbox tooltip is-tooltip-multiline" style="margin-top: 16px;" data-tooltip="If checked, the storage of all databases backed up through this server will be updated as well.">
                            <input v-model="applyChangeToDatabases" type="checkbox">
                            <span style="font-size: 14px; padding-top: 3px; padding-left: 5px;">Also update the storage of the databases belonging to this server</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" style="margin-top: 10px;">
                <div class="column is-3">
                    <div @click="changeStorage" :disabled="changingStorage" :class="{ 'is-loading': changingStorage }" class="button custom-button-size is-fullwidth is-info">Change Storage</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="changingStorage">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';

export default {
    props: ['server'],

    data() {
        return {
            storages: [],
            selectedStorage: null,
            changingStorage: false,
            applyChangeToDatabases: false,
        }
    },

    mounted() {
        this.getStorages();
    },

    methods: {
        close() {
            if (!this.creatingStorage) {
                Event.$emit('changeServerDefaultDatabaseStorageModalClosed');
            }
        },

        getStorages() {
            Api().get('users/current/storages')
                .then((success) => {
                    this.storages = success.data.data;
                    for (var i = 0; i <= this.storages.length; i++) {
                        if (this.storages[i].id == this.server.default_database_storage.id) {
                            this.selectedStorage = this.storages[i].id;
                        }
                    }
                });
        },

        changeStorage() {
            if (this.changingStorage) {
                return;
            }
            
            this.changingStorage = true;

            var defaultDatabaseStorage = {
                storage_id: this.selectedStorage,
                apply_change_to_databases: this.applyChangeToDatabases,
            };

            Api().put('servers/' + this.server.id + '/default-database-storage', defaultDatabaseStorage)
                .then((success) => {
                    Event.$emit('serverDefaultDatabaseStorageChanged', () => {
                        swal('Success!', 'The default storage was changed successfully.', 'success');
                    });
                })
                .finally(() => {
                    this.changingStorage = false;
                });
        },
    },
}
</script>
